import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavItemProps {
  icon: string;
  label: string;
  url: string;
}

const NavItem: React.FC<NavItemProps> = ({ icon, label, url }) => {
  const location = useLocation();
  const isActive = location.pathname === url;

  return (
    <div className="1.5xl:px-3 2xl:px-5">
      <Link
        to={url}
        className={`flex items-center gap-3 mt-1 px-4 py-2 w-full rounded-lg transition-all duration-200 ${
          isActive
            ? 'bg-honoursOrange text-white font-semibold shadow-md'
            : 'text-white hover:bg-primary-200 hover:bg-opacity-50'
        }`}
      >
        <img src={icon} alt="" className="w-5 h-5 object-contain" />
        <span className="text-sm">{label}</span>
      </Link>
    </div>
  );
};

export default NavItem;
